'use strict'

function getRules() {
    return {
        name: [
            { required: true, message: '请填写名称', trigger: ['blur', 'change'] },
        ],
        parentId: [
            { required: true, message: '请选择上级目录', trigger: ['blur', 'change'] },
        ]
    }
}
export {
    getRules
}
